/*
  KYARNA GLOBAL CART v9
  - Ajax Add to Cart (no page refresh)
  - Instant cart count update
  - Drawer open after add
  - Sticky ATC on mobile product page
*/

(function (w) {
  'use strict';

  /* ====================================================
     1. CART COUNT UPDATE
  ==================================================== */
  function updateCartCount(count) {
    // Update all cart count elements
    document.querySelectorAll('.cart-count-bubble, [data-cart-count], #kynav-cart-badge').forEach(function(el) {
      if (el.id === 'kynav-cart-badge') {
        el.textContent = count;
        if (count > 0) el.classList.add('on');
        else el.classList.remove('on');
      } else {
        var span = el.querySelector('span[aria-hidden]') || el;
        if (span) span.textContent = count;
        if (count > 0) el.removeAttribute('hidden');
      }
    });
  }

  /* ====================================================
     2. CART REFRESH (sections API)
  ==================================================== */
  function KyarnaRefreshCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'kyarna-atc', data: { itemCount: cart.item_count } }
        }));
        // Refresh cart drawer if exists
        fetch('/?sections=cart-icon-bubble,cart-drawer', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (sections) {
            if (sections['cart-icon-bubble']) {
              var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
              var nb = doc.querySelector('.cart-count-bubble');
              var ob = document.querySelector('.cart-count-bubble');
              if (nb && ob) { ob.innerHTML = nb.innerHTML; ob.removeAttribute('hidden'); }
            }
            if (sections['cart-drawer']) {
              var drawerEl = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer');
              if (drawerEl) {
                var tmpDoc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
                var newDrawer = tmpDoc.querySelector('cart-drawer, #CartDrawer, .cart-drawer');
                if (newDrawer) drawerEl.innerHTML = newDrawer.innerHTML;
              }
            }
          })
          .catch(function () {});
      })
      .catch(function () {});
  }

  /* ====================================================
     3. OPEN CART DRAWER
  ==================================================== */
  function openCartDrawer() {
    // Try Balance theme cart drawer
    var drawerEl = document.querySelector('cart-drawer');
    if (drawerEl && typeof drawerEl.open === 'function') {
      drawerEl.open();
      return;
    }
    // Try triggering cart icon click
    var cartBtn = document.querySelector('[href*="/cart"] .svg-wrapper, a[href="/cart"] svg');
    if (cartBtn) {
      var parent = cartBtn.closest('[href*="/cart"]');
      if (parent) parent.click();
      return;
    }
    // Dispatch event that Balance theme listens to
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
  }

  /* ====================================================
     4. AJAX ADD TO CART
  ==================================================== */
  function KyarnaATC(btn, variantId, fallbackUrl, opts) {
    if (!variantId) return;
    var options = opts || {};
    var openDrawer = options.openDrawer !== false; // default true
    var orig = btn ? btn.innerHTML : 'Add to Cart';
    if (btn) {
      btn.innerHTML = '<span style="opacity:0.7">Adding...</span>';
      btn.style.pointerEvents = 'none';
      btn.disabled = true;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status && data.status !== 200) {
        if (btn) { btn.innerHTML = orig; btn.style.pointerEvents = ''; btn.disabled = false; }
        if (fallbackUrl) w.location.href = fallbackUrl;
        return;
      }
      if (btn) {
        btn.innerHTML = '\u2713 Added';
        btn.style.pointerEvents = '';
        btn.disabled = false;
        setTimeout(function () { btn.innerHTML = orig; }, 2200);
      }
      KyarnaRefreshCart();
      if (openDrawer) {
        setTimeout(openCartDrawer, 100);
      }
    })
    .catch(function () {
      if (btn) { btn.innerHTML = orig; btn.style.pointerEvents = ''; btn.disabled = false; }
      if (fallbackUrl) w.location.href = fallbackUrl;
    });
  }

  /* ====================================================
     5. INTERCEPT NATIVE ADD TO CART FORMS
     Converts standard form submissions to Ajax
  ==================================================== */
  function interceptForms() {
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form || form.getAttribute('action') !== '/cart/add') return;
      // Only intercept product forms
      var submitBtn = form.querySelector('[name="add"], [type="submit"]');
      var variantInput = form.querySelector('[name="id"]');
      if (!variantInput || !variantInput.value) return;
      e.preventDefault();
      KyarnaATC(submitBtn, variantInput.value, null, { openDrawer: true });
    }, true);
  }

  /* ====================================================
     6. EVENT DELEGATION FOR [data-kyarna-atc]
  ==================================================== */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-kyarna-atc]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    KyarnaATC(btn, btn.getAttribute('data-variant-id'), btn.getAttribute('data-product-url'));
  }, true);

  /* ====================================================
     7. STICKY ATC (mobile product page)
  ==================================================== */
  function initStickyATC() {
    if (w.innerWidth > 749) return;
    var main = document.querySelector('main[data-template]');
    var isProduct = (main && main.getAttribute('data-template') === 'product') ||
                   document.body.classList.contains('template-product');
    if (!isProduct) return;

    var bar = document.getElementById('kpe-sticky');
    var stickyBtn = document.getElementById('kpe-sticky-btn');
    if (!bar || !stickyBtn) return;

    function findATC() {
      return document.querySelector('buy-buttons [name="add"]') ||
             document.querySelector('[name="add"]') ||
             document.querySelector('form[action*="/cart/add"] button[type="submit"]');
    }

    function attachObserver(realBtn) {
      new IntersectionObserver(function (entries) {
        bar.style.display = entries[0].isIntersecting ? 'none' : 'flex';
      }, { threshold: 0 }).observe(realBtn);

      stickyBtn.addEventListener('click', function () {
        var rb = findATC();
        if (rb) {
          var variantInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
          if (variantInput) {
            KyarnaATC(stickyBtn, variantInput.value, null, { openDrawer: true });
          } else {
            rb.click();
            stickyBtn.textContent = '\u2713 Added';
            setTimeout(function () { stickyBtn.textContent = 'Add to Cart'; }, 2200);
          }
        }
      });
    }

    var existing = findATC();
    if (existing) { attachObserver(existing); return; }

    var mo = new MutationObserver(function (mutations, observer) {
      var btn = findATC();
      if (btn) { observer.disconnect(); attachObserver(btn); }
    });
    mo.observe(document.getElementById('MainContent') || document.body, {
      childList: true, subtree: true
    });
    setTimeout(function () { mo.disconnect(); }, 8000);
  }

  /* ====================================================
     8. EXPOSE + INIT
  ==================================================== */
  w.KyarnaRefreshCart = KyarnaRefreshCart;
  w.KyarnaATC         = KyarnaATC;
  w.kcolRefreshCart   = KyarnaRefreshCart;
  w.kpeRefreshCart    = KyarnaRefreshCart;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initStickyATC();
      interceptForms();
    });
  } else {
    initStickyATC();
    interceptForms();
  }

}(window));
